import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { PhoneCode } from 'src/app/core/Models/interfaces/phoneCodes';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.css']
})
export class ContactDetailsComponent implements OnInit {
  showContact: boolean = true;
  @Input() formGroupName!: string;
  @Input() formSubmitted!: boolean;
  @Input() isThirdPartyComp!: boolean;
  @Input('uniQueId') uniQueId :number= 0
  isChecked: boolean = false;
  showList: boolean = false;
  @Input() isEdit!: boolean;
  @Input() isUser: any = null;
  contactForm!: FormGroup;
  phoneCodes: PhoneCode[] = [];
  phoneCode = [{
    id: '+971',
    name: 'United Arab Emirates (+971)'
  }, {
    id: '+91',
    name: 'India (+91)'
  }
  ]
  constructor(
    private rootFormGroup: FormGroupDirective,
    private apiService: ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.contactForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.contactForm.controls['userName']?.disable();
    this.contactForm.controls['password']?.disable();
    this.getPhoneCodes();
  }
  getPhoneCodes() {
    this.apiService.getPhoneCodes()
      .subscribe({
        next: (response: any) => {

          if (response?.status == 'success') {
            const phoneCodes: PhoneCode[] = response.data || [];
            this.phoneCodes = phoneCodes.map(phoneCode => {
              phoneCode.countryFlag = `./assets/images/flags/${phoneCode.countryCode}.png`;
              return phoneCode;
            });
            //  if(this.country && !this.formData.value.phoneCode){
            //   const codes = this.phoneCodes.filter(phoneCode=>phoneCode.countryId=== this.country.countryId);
            //   this.resetPhoneCode(codes);
            //  }
          }
        },
        error: (error: any) => { }
      });
  }
  showDropdown() {
    this.showList = !this.showList;
  }
  checkUser(event: any) {
    this.isChecked = !this.isChecked;
    if (event.target.checked) {
      this.contactForm.controls['isUser']?.patchValue(1);
      this.contactForm.controls['userName']?.enable();
      this.contactForm.controls['password']?.enable();
    } else {
      this.contactForm.controls['isUser']?.patchValue(0);
      this.contactForm?.controls?.['userName']?.patchValue('');
      this.contactForm?.controls?.['password']?.patchValue('');
      this.contactForm.controls['userName']?.disable();
      this.contactForm.controls['password']?.disable();
    }
  }
}
